import { alpha, Theme } from '@mui/material'

import { ECampaignExecutionStatus } from '~/features/campaigns/models'

export type TExecutionStatusBadgeSettings = {
  label: string
  backgroundColor: string
  borderColor: string
  color: string
}

export function getExecutionStatusBadgeSettings(
  theme: Theme,
  status: ECampaignExecutionStatus | null | undefined,
  isArchived?: boolean,
): TExecutionStatusBadgeSettings {
  if (isArchived) {
    return {
      label: 'Archived',
      backgroundColor: alpha(theme.palette.error.dark, 0.1),
      borderColor: alpha(theme.palette.error.dark, 0.5),
      color: theme.palette.error.dark,
    }
  }

  switch (status) {
    case ECampaignExecutionStatus.notStarted:
      return {
        label: 'Draft',
        backgroundColor: theme.palette.divider,
        borderColor: alpha(theme.palette.divider, 0.5),
        color: theme.palette.text.secondary,
      }
    case ECampaignExecutionStatus.paused:
      return {
        label: 'Paused',
        backgroundColor: alpha(theme.palette.warning.dark, 0.1),
        borderColor: alpha(theme.palette.warning.dark, 0.5),
        color: theme.palette.warning.dark,
      }
    case ECampaignExecutionStatus.completed:
      return {
        label: 'Completed',
        backgroundColor: alpha(theme.palette.success.dark, 0.1),
        borderColor: alpha(theme.palette.success.dark, 0.5),
        color: theme.palette.success.dark,
      }
    case ECampaignExecutionStatus.inProgress:
    default:
      return {
        label: 'Active',
        backgroundColor: alpha(theme.palette.success.dark, 0.1),
        borderColor: alpha(theme.palette.success.dark, 0.5),
        color: theme.palette.success.dark,
      }
  }
}
